<template>
    <div class="subscription-card" :class="{ [subscribe.plan.type]: true }">
        <div class="remove-sub">
            <span class="material-icons">delete</span>
        </div>
        <div class="container">
            <div class="background">
                <DynamicSvg :name="subscribe.icon" style="width: 80px; height: 80px" />
            </div>
            <div class="subscription-description">
                <div>
                    <div class="subscription-title">{{ subscribe.plan.title }}</div>
                    <div class="subscription-alt-title">{{ subscribe.plan.altTitle }}</div>
                </div>
                <div class="subscription-details">
                    <div class="detail-item">
                        <div v-if="subscribe.plan.type === 'supsis'">{{ $t("report.agentCount") }}</div>
                        <div v-if="subscribe.plan.type === 'chatbot'">{{ $t("billing.sessionCount") }}</div>
                        <div
                            v-if="
                                ['whatsapp', 'whatsapp-business', 'messenger', 'instagram'].includes(
                                    subscribe.plan.type
                                )
                            "
                        >
                            {{ $t("billing.numberOfChannels") }}
                        </div>
                        <div>{{ $t("billing.subType") }}</div>
                    </div>
                    <div class="detail-value">
                        <div>{{ getValue() }}</div>
                        <div>{{ formatPeriod(subscribe.period) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicSvg from "../../DynamicSvg.vue";

export default {
    name: "SubscriptionCard",
    props: ["subscribe", "details"],
    components: {
        DynamicSvg,
    },
    methods: {
        formatPeriod(period) {
            const periods = {
                monthly: this.$t("billing.monthly"),
                "monthly-3": this.$t("billing.threeMonthly"),
                "monthly-6": this.$t("billing.sixMonthly"),
                annual: this.$t("billing.yearly"),
                forever: this.$t("billing.forever"),
            };
            return periods[period];
        },
        getValue() {
            const type = this.subscribe.plan.type;
            if (type === "supsis") {
                return this.details.agentCount;
            } else if (type === "chatbot") {
                const chatbotFeature = this.subscribe.plan.features.find((f) => f.type === "chatbot");
                return chatbotFeature ? chatbotFeature.maxSessionCount : 0;
            } else if (["whatsapp", "whatsapp-business"].includes(type)) {
                return this.details.whatsappChannel;
            } else if (type === "instagram") {
                return this.details.instagramChannel;
            } else if (type === "messenger") {
                return this.details.messengerChannel;
            } else if (type === "trendyol") {
                return this.details.trendyolChannel;
            } else if (type === "meta-lead") {
                return this.details.metaLeadChannel;
            }
        },
    },
};
</script>

<style lang="scss">
.subscription-card {
    color: black;
    display: flex;
    align-items: center;
    border: 1px solid #d0d0d0;
    border-radius: 8px;
    position: relative;
    width: 400px;
    user-select: none;
    &.supsis {
        .background > svg {
            width: 100px !important;
        }

        .background > svg > g > path:nth-child(3),
        .background > svg > g > path:nth-child(2) {
            fill: white;
        }
    }

    &.whatsapp,
    &.whatsapp-business {
        .remove-sub {
            background: #58ca64 !important;
        }

        .background {
            background: #58ca64 !important;

            svg > path {
                stroke: white !important;
            }
        }
    }

    &.whatsapp {
        svg > path {
            fill: white !important;
        }
    }

    &.chatbot {
        .container > div.background > svg {
            path {
                fill: white !important;
            }
        }
    }

    .remove-sub {
        position: absolute;
        z-index: 2;
        right: -15px;
        top: -15px;
        border-radius: 100%;
        background-color: #ec4b1d;
        border: 3px solid white;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
    }

    .container {
        position: relative;
        overflow: hidden;
        padding: 20px 30px;
        border-radius: 7px;

        .background {
            position: absolute;
            right: -30px;
            top: -30px;
            background: #ec4b1d;
            width: 200px;
            height: 200px;
            border-radius: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .subscription-description {
            margin-right: 150px;
            text-transform: uppercase;
            display: flex;
            flex-direction: column;
            gap: 10px;

            .subscription-title {
                font-weight: bold;
                font-size: 28px;
            }

            .subscription-alt-title {
                font-weight: bold;
                font-size: 18px;
            }
        }

        .subscription-details {
            display: flex;
            align-items: center;
            gap: 10px;

            .detail-item {
                font-size: 14px;
            }

            .detail-value {
                font-size: 14px;
                font-weight: bold;
            }
        }
    }
}
</style>
